module.exports = __webpack_public_path__ + "img/qrcode.aea8f7ac.png";